import React, { useState } from "react";

export default function PartnerCard({ item }) {
  const [seeMore, setSeeMore] = useState(false);

  return (
    <div className="bg-white max-w-2xl shadow overflow-hidden sm:rounded-lg m-auto mb-5">
      <div className="flex items-center">
        {item?.logo && <img className="inline-block" src={`https://tudoincendio.ateny.space/${item?.logo}`} style={{objectFit: 'cover', height:50, width:50}} alt="" />}
        <div className="px-4 py-5 sm:px-6 inline-block">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {item?.razao_social}
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">{item?.nome}</p>
        </div>
      </div>
      <div className="border-t border-gray-200">
        <dl>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Endereço</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {item?.endereco + " - " + item?.cidade + ", " + item?.estado}
            </dd>
          </div>
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Telefone</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {item?.telefone}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Email</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {item?.email}
            </dd>
          </div>
          {/* <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Salary</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              $10,000
            </dd>
          </div> */}
          <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Estrutura operacional
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {item?.estrutura_operacional?.split(',').map((line) => (
                <div>{line + "; "}</div>
              ))}
            </dd>
          </div>
          <div className={`${seeMore ? "block" : "hidden"}`}>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Instalação</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.instalador?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Iluminação de emergência
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.iluminacao_emergencia?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Alarmes de incêndio
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.alarmes_incendio?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Sistema de detecção
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.sistema_detectacao?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Porta corta-fogo
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.porta_corta_fogo?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Casa de bombas
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.casa_bombas?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Proteção passiva
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.protecao_passiva?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Sprinklers</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.sprinklers?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Escada pressurizada
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.escada_pressurizada?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Proteção passiva
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.protecao_passiva?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">projetos</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.projetos?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Assitência técnica (manutenção)
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.assistencia_tecnica?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Processo AVCB
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {item?.processo_avcb?.split(',').map((line) => (
                  <div>{line + "; "}</div>
                ))}
              </dd>
            </div>
          </div>
        </dl>
      </div>
      <div
        onClick={() => setSeeMore(!seeMore)}
        className="text-blue-600 text-center text-sm pb-2 cursor-pointer"
      >
        {seeMore ? "Ver menos -" : "ver mais +"}
      </div>
    </div>
  );
}
